import { useEffect } from "react";
import { apiClient } from "../services/api/http";
import { useAuthContext } from "../context/AuthContext";

// Resolves tenant branding once per login and applies it as CSS custom
// properties on <html> — every component that already uses
// var(--tenant-primary) picks it up automatically, no per-component fetch.
// Null/failed branding silently falls back to the default values already
// defined in designSystem.css.
const HEX_RE = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

function applyVar(name, value, fallback) {
  const root = document.documentElement;
  if (value && HEX_RE.test(value)) root.style.setProperty(name, value);
  else root.style.removeProperty(name);
}

export default function BrandingBootstrap() {
  const { user } = useAuthContext() || {};

  useEffect(() => {
    if (!user) return undefined;
    let cancelled = false;
    apiClient.get("/api/branding").then((res) => {
      if (cancelled) return;
      const branding = res?.data?.branding;
      // Overrides the design system's own primary token — every existing
      // primary button/active-nav/link already consumes --pg-primary, so
      // this is the platform-wide application point without new CSS.
      applyVar("--pg-primary", branding?.primaryColor);
      applyVar("--pg-primary-hover", branding?.primaryColor);
      applyVar("--pg-primary-pressed", branding?.primaryColor);
      applyVar("--tenant-accent", branding?.accentColor);
      if (branding?.logoUrl) {
        window.__GAPSMANIA_TENANT_LOGO__ = branding.logoUrl;
        window.dispatchEvent(new CustomEvent("gapsmania:branding", { detail: branding }));
      }
    }).catch(() => {
      // Branding is a cosmetic enhancement — never break the app on failure.
    });
    return () => { cancelled = true; };
  }, [user]);

  return null;
}
